export default __webpack_public_path__ + "static/media/empty.0c98fa50.svg";